import { Row } from '@cdab/scania/qpr/components'
import styled from 'styled-components'

export const StyledRow = styled(Row)`
  display: flex;
  flex-wrap: nowrap;
  height: 100%;
`

export const EmptyScreenWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-self: center;
  width: 100%;
`

export const ActionRow = styled.div`
  align-items: center;
  background: white;
  background: white;
  border-bottom: 1px solid #dbdfe6;
  display: flex;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 0;
  padding: 8px;
  height: 60px;
`

export const ActionRowMobile = styled.div`
  align-items: center;
  display: flex;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 0;
  padding: 8px;
  margin-left: 8px;
  margin-right: 8px;
  height: 40px;
`

export const Left = styled.div``

export const Right = styled.div`
  justify-self: end;
`

export const ActionRowTitle = styled.h4`
  margin: 0;
  text-transform: capitalize;
  display: flex;
  flex-grow: 1;
  justify-content: center;
`
export const TabsContent = styled.div`
  padding: 24px 24px 48px;
`
